import {
  mergeStyles,
  Modal,
  PrimaryButton,
  ResponsiveMode,
  Stack,
  useTheme,
} from '@fluentui/react';
import React, { useEffect } from 'react';

export const InlineConsent = (props: {
  children: React.ReactNode;
  content: string | JSX.Element;
}): JSX.Element => {
  const { children, content } = props;
  const theme = useTheme();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const width = Math.min(window.innerWidth, window.outerWidth) - 64;

  const handleOnSubmit = () => {
    setIsModalOpen(false);
  };

  const onSubmitConsentButton = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    // Diasble body scroll when Modal open
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      // Enable body scroll when Modal unmounts
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);

  return (
    <>
      <a
        style={{
          cursor: 'pointer',
          color: theme.palette.black,
          textDecoration: 'underline',
        }}
        onClick={onSubmitConsentButton}
      >
        <strong>{children}</strong>
      </a>
      <Modal
        isOpen={isModalOpen}
        responsiveMode={ResponsiveMode.small}
        allowTouchBodyScroll={true}
        styles={{
          main: {
            borderRadius: theme.effects.roundedCorner6,
            height: 'auto',
            background: theme.palette.black,
            overflowY: 'scroll',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <div
          className={mergeStyles({
            padding: '1rem',
            width: width,
            borderRadius: `${theme.effects.roundedCorner6} ${theme.effects.roundedCorner6} 0 0`,
            background: theme.palette.black,
          })}
        >
          <Stack horizontal horizontalAlign="start">
            <h3
              style={{
                color: theme.palette.neutralLight,
                fontWeight: 600,
                fontSize: '20px',
                margin: 0,
              }}
            >
              {children}
            </h3>
          </Stack>
          <Stack
            style={{
              color: theme.palette.neutralLight,
              paddingTop: '1rem',
              paddingBottom: '1rem',
              maxHeight: window.innerHeight / 1.8,
              overflow: 'auto',
              WebkitOverflowScrolling: 'touch',
              // boxShadow: `inset 0px 11px 8px -10px #CCC,
              // inset 0px -11px 8px -10px #CCC`,
            }}
          >
            <div
              style={{
                paddingRight: '1rem',
              }}
            >
              {content}
            </div>
          </Stack>
        </div>
        <Stack horizontal horizontalAlign="center" style={{ padding: '1rem' }}>
          <PrimaryButton
            className={mergeStyles({
              height: '2.5rem',
              minWidth: '8rem',
              borderRadius: theme.effects.roundedCorner6,
              boxShadow: theme.effects.elevation8,
              fontSize: '16px',
              color: theme.palette.neutralLight,
              background: theme.palette.themePrimary,
            })}
            onClick={() => handleOnSubmit()}
          >
            Done
          </PrimaryButton>
        </Stack>
      </Modal>
    </>
  );
};
